interface Props {
  name: string;
  company: string;
  term: string;
  extenddate: string;
  enddate: string;
  total: string;
}

const CustomerLicence = ({
  name,
  company,
  term,
  extenddate,
  enddate,
  total,
}: Props) => {
  const containerClass =
    "w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50";

  return (
    <div className={containerClass}>
      <p className="w-3/12 text-left">{name}</p>
      <p className="w-2/12 text-center">{company}</p>
      <p className="w-2/12 text-center">{term}</p>
      <p className="w-2/12 text-center">{extenddate}</p>
      <p className="w-2/12 text-center">{enddate}</p>
      <p className="w-1/12 text-center">{total}</p>
    </div>
  );
};

export default CustomerLicence;
